<app-add-tickets  [type]="type" [id]="" [prospect]="" [fromDetails]="fromDetails"></app-add-tickets>